import React from 'react';
import { Navbar } from '../components/Navbar';
import { TrustBar } from '../components/TrustBar';
import { RelatedFeatures } from '../components/RelatedFeatures';
import { Footer } from '../components/Footer';
import { ScraperHero } from '../components/google-maps-scraper/ScraperHero';
import { ScraperShowcase } from '../components/google-maps-scraper/ScraperShowcase';
import { ScraperWorkflow } from '../components/google-maps-scraper/ScraperWorkflow';
import { ScraperValueProps } from '../components/google-maps-scraper/ScraperValueProps';
import { ScraperProductTour } from '../components/google-maps-scraper/ScraperProductTour';
import { DataFieldsSection } from '../components/google-maps-scraper/DataFieldsSection';
import { ScraperDemo } from '../components/google-maps-scraper/ScraperDemo';
import { ScraperComparison } from '../components/google-maps-scraper/ScraperComparison';
import { ScraperPricing } from '../components/google-maps-scraper/ScraperPricing';
import { ScraperUseCases } from '../components/google-maps-scraper/ScraperUseCases';
import { ScraperFAQ } from '../components/google-maps-scraper/ScraperFAQ';
import { ScraperCta } from '../components/google-maps-scraper/ScraperCta';
import { DatabaseIcon, BookOpenIcon } from 'lucide-react';
const scraperFeatures = [{
  title: 'Restaurant contacts database',
  description: 'Access restaurant contacts with reviews and ratings.',
  href: 'https://openmart.com/data/restaurants',
  cta: 'Explore restaurants',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Car dealer contacts database',
  description: 'Find car dealerships with location and contact info.',
  href: 'https://openmart.com/data/car-dealer',
  cta: 'Explore car dealers',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Cafe contacts database',
  description: 'Discover cafes and coffee shops with reviews.',
  href: 'https://openmart.com/data/cafe',
  cta: 'Explore cafes',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Beauty salon contacts database',
  description: 'Access beauty salons with ratings and services.',
  href: 'https://openmart.com/data/beauty-salons',
  cta: 'Explore beauty salons',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Nail salon contacts database',
  description: 'Find nail salons with contact details and reviews.',
  href: 'https://openmart.com/data/nail-salons',
  cta: 'Explore nail salons',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Getting started guide',
  description: 'Learn how to use Openmart to scrape Google Maps.',
  href: 'https://openmart.com/product-tutorials/onboarding',
  cta: 'Read guide',
  type: 'Tutorial',
  color: 'blue' as const,
  icon: BookOpenIcon
}];
export function GoogleMapsScraper() {
  return <div className="min-h-screen bg-white font-sans selection:bg-blue-100 selection:text-blue-900" data-id="element-6508">
      <Navbar data-id="element-6509" />
      <main data-id="element-6510">
        <ScraperHero data-id="element-6511" />
        <TrustBar data-id="element-6512" />
        <ScraperShowcase data-id="element-6513" />
        <ScraperWorkflow data-id="element-6514" />
        <ScraperValueProps data-id="element-6515" />
        <ScraperProductTour data-id="element-6516" />
        <DataFieldsSection data-id="element-6517" />
        <ScraperDemo data-id="element-6518" />
        <ScraperComparison data-id="element-6519" />
        <ScraperPricing data-id="element-6520" />
        <ScraperUseCases data-id="element-6521" />
        <ScraperFAQ data-id="element-6522" />
        <RelatedFeatures features={scraperFeatures} data-id="element-6523" />
        <ScraperCta data-id="element-6524" />
      </main>
      <Footer data-id="element-6525" />
    </div>;
}